import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeGradient } from "../../actions/gradientAction";
import {GradientFull} from '../../styles/Gradient-Styles';

const FullGradient = () => {
  const dispatch = useDispatch();
  const gradient = useSelector((state) => state.gradient.gradient);
  const { colors } = gradient;
  return (
    <GradientFull className = "animate__animated animate__zoomIn"
      style={{
        background: `linear-gradient(${colors.direction},${colors.start}, ${colors.end})`,
      }}
      onClick={() => dispatch(removeGradient())}
    ></GradientFull>
  );
};

export default FullGradient;